/**
 * Argus — helpers pentru CRUD watched_paths (continuous-monitoring-fs).
 */

import { apiFetch } from './api';
import { wsClient } from './wsClient';

export type FsEventType = 'created' | 'modified' | 'deleted' | 'renamed';

export interface WatchedPathItem {
  readonly id: string;
  readonly path: string;
  readonly recursive: boolean;
  readonly eventTypes: readonly FsEventType[];
  readonly extensionsWhitelist: readonly string[];
  readonly extensionsBlacklist: readonly string[];
  readonly isActive: boolean;
  readonly createdBy: string;
  readonly createdAt: string;
  readonly updatedAt: string;
}

export interface WatchedPathsResponse {
  readonly agentId: string;
  readonly items: readonly WatchedPathItem[];
  readonly count: number;
}

export interface WatchedPathInput {
  readonly path: string;
  readonly recursive: boolean;
  readonly eventTypes: readonly FsEventType[];
  readonly extensionsWhitelist?: readonly string[];
  readonly extensionsBlacklist?: readonly string[];
}

export async function fetchWatchedPaths(agentId: string): Promise<WatchedPathsResponse> {
  const result = await apiFetch<WatchedPathsResponse>(
    `/api/v1/agents/${agentId}/watched-paths`
  );
  return result.data;
}

/**
 * Bloc v1.0.10 #B — set_watched_paths WS direct (refactor REST→WS).
 * Frontend → WS → Node (DB transaction direct via mysql2 pool) → Agent (apply config) → result.
 * Eliminăm hop REST POST PHP — pure WS round-trip cu correlation prin commandId.
 */
export async function emitSetWatchedPaths(
  agentId: string,
  paths: readonly WatchedPathInput[],
  justification: string
): Promise<{ pathsCount: number }> {
  await wsClient.requestSetWatchedPaths(agentId, paths, justification);
  return { pathsCount: paths.length };
}
